import { combineReducers } from "redux";
import {userProfile, userUpdateProfile } from "./UserProfile";
import userOtp from "./UserOtp";
import {userAddVendor, userUpdateVendor, userVendor,userVendorUser} from "./UserVendor";
import { userAddSubVendor, userDetailSubVendor, userSubVendor, userUpdateSubVendor } from "./UserSubVendor";
import { userAddCompliance, userAddOnBoardCompliance, userApproveCompliance, userCompliance, userConfigCompliance, userOnBoardCompliance, userUpdateCompliance } from "./UserCompliance";
import { userAddDriver, userDriver, userMatrixDriver, userMoreDriver, userTicketDriver, userUpdateDriver } from "./UserDriver";
import { userAddFaq, userDeleteFaq, userFaq, userFaqSection, userUpdateFaq } from "./UserFAQ";
import { userAddCar, userCar, userDeleteCar, userFacilities, userUpdateCar } from "./UserCar";
import { userAddTag, userRating, userTag, userUpdateTag } from "./UserTag";
import { userDailyCustomer, userRideAnalytic, userRideDetails, userTotalRegistration } from "./UserDashboard";
import { userCustomer, userMatrixCustomer, userTicketCustomer, userUpdateCustomer } from "./UserCustomer";
import { userAddVehicle, userDeleteVehicle, userUpdateVehicle, userVehicle, userMatrixVehicle, userMoreVehicle } from "./UserVehicle";
import userRegistration from "./UserRegistration";
import { userCabRide, userDashboardFeedback, userOurCar, userRideAccept, userTopDriver, userTopSubVendor, userTopVendor } from "./UserTopSection";
import { userAssignDriver, userCancelTrip, userInvoice, userInvoiceDownload, userSOSAlert, userTrip,getReservationDetails } from "./UserTrip";
import { userNotification, userNotificationCount, userNotificationSeen } from "./UserNotification";
import { userAssignVehicle, userListAssignedVehicle, userRequestVehicle, userUpdateAssignDriver, userUpdateAssignSubVendor, userUpdateAssignVehicle } from "./UserAllot";
import { userChooseYourService, userUpdateChooseYourService } from "./UserChooseYourService";
import { userAddRateCard, userBaseFuel, userRateCard } from "./UserRateCard";
import { userServiceCity, userServiceRegion, userAddServiceRegion, userSubVendorRegion, userServiceAddSubVendorRegion } from "./UserServiceCity";
import userLogout from "./UserLogout";
import { userBooking } from "./UserReport";
import { userLogin, userMagicToken, userTokenVerify } from "./UserLogin";
import { commonReducer } from "./CommonReducer";

const rootReducer = combineReducers({
  userProfile: userProfile,
  userUpdateProfile: userUpdateProfile,
  userLogin: userLogin,
  userOtp: userOtp,
  userVendor: userVendor,
  userAddVendor: userAddVendor,
  userUpdateVendor: userUpdateVendor,
  userSubVendor: userSubVendor,
  userAddSubVendor: userAddSubVendor,
  userUpdateSubVendor: userUpdateSubVendor,
  userDetailSubVendor: userDetailSubVendor,
  userCompliance: userCompliance,
  userAddCompliance:userAddCompliance,
  userUpdateCompliance: userUpdateCompliance,
  userOnBoardCompliance: userOnBoardCompliance,
  userAddOnBoardCompliance:userAddOnBoardCompliance,
  userAddDriver: userAddDriver,
  userDriver: userDriver,
  userUpdateDriver: userUpdateDriver,
  userFaq: userFaq,
  userAddFaq: userAddFaq,
  userUpdateFaq: userUpdateFaq,
  userDeleteFaq: userDeleteFaq,
  userCar: userCar,
  userAddCar: userAddCar,
  userUpdateCar: userUpdateCar,
  userDeleteCar: userDeleteCar,
  userFacilities:userFacilities,
  userTag: userTag,
  userAddTag: userAddTag,
  userUpdateTag:userUpdateTag,
  userRating: userRating,
  userDailyCustomer:userDailyCustomer,
  userRideAnalytic:userRideAnalytic,
  userTotalRegistration:userTotalRegistration,
  userRideDetails:userRideDetails,
  userCustomer:userCustomer,
  userConfigCompliance:userConfigCompliance,
  userTicketDriver: userTicketDriver,
  userMoreDriver: userMoreDriver,
  userMatrixDriver: userMatrixDriver,
  userAddVehicle: userAddVehicle,
  userVehicle: userVehicle,
  userUpdateVehicle: userUpdateVehicle,
  userDeleteVehicle: userDeleteVehicle,
  userApproveCompliance:userApproveCompliance,
  userRegistration: userRegistration,
  userFaqSection:userFaqSection,
  userOurCar:userOurCar,
  userCabRide:userCabRide,
  userTopVendor:userTopVendor,
  userTopSubVendor:userTopSubVendor,
  userTopDriver:userTopDriver,
  userRideAccept:userRideAccept,
  userDashboardFeedback:userDashboardFeedback,
  userTicketCustomer: userTicketCustomer,
  userMatrixCustomer: userMatrixCustomer,
  userTrip: userTrip,
  userNotification: userNotification,
  userNotificationCount: userNotificationCount,
  userNotificationSeen: userNotificationSeen,
  userRequestVehicle:userRequestVehicle,
  userListAssignedVehicle:userListAssignedVehicle,
  userAssignVehicle:userAssignVehicle,
  userUpdateAssignVehicle:userUpdateAssignVehicle,
  userChooseYourService:userChooseYourService,
  userUpdateAssignDriver:userUpdateAssignDriver,
  userUpdateAssignSubVendor:userUpdateAssignSubVendor,
  userMatrixVehicle:userMatrixVehicle,
  userMoreVehicle:userMoreVehicle,
  userRateCard:userRateCard,
  userAddRateCard:userAddRateCard,
  userServiceCity:userServiceCity,
  userServiceRegion:userServiceRegion,
  userAddServiceRegion:userAddServiceRegion,
  userSubVendorRegion: userSubVendorRegion,
  userServiceAddSubVendorRegion: userServiceAddSubVendorRegion,
  userVendorUser:userVendorUser,
  userSOSAlert:userSOSAlert,
  userUpdateCustomer:userUpdateCustomer,
  userUpdateChooseYourService:userUpdateChooseYourService,
  userLogout:userLogout,
  userCancelTrip:userCancelTrip,
  userAssignDriver:userAssignDriver,
  userBooking:userBooking,
  userBaseFuel:userBaseFuel,
  userInvoice:userInvoice,
  userInvoiceDownload:userInvoiceDownload,
  userMagicToken:userMagicToken,
  userTokenVerify:userTokenVerify,
  commonReducer:commonReducer,
  getReservationDetails:getReservationDetails,
});

export default rootReducer;
